import { Tab, Tabs, IconButton, Box, Divider } from "@mui/material";
import { Product, Services } from "./detail";
import { useState } from "react";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate } from "react-router";
import SEO from "./SEO";

export const ServicesContainer = () => {
  const [value, setValue] = useState(0);
  const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <SEO
        title="Elegant Prime"
        description="All in One Basic Software for billing, inventory, and business management. Perfect solution for small and medium businesses."
        keywords="All-in-One Salon Management Software – POS, CRM & Billing, Salon & Spa Software – streamline operations, retain clients, boost revenue, Billing & Inventory Management Software for salons, Appointment Scheduling App for salons & spas,
Salon CRM Software India – customer retention made easy, Online Salon Booking System for clients, Loyalty Program Features to reward & retain customers, Staff Scheduling Software – manage beauticians & salon staff with ease,
Beauty Parlour Software with GST Billing – fast, compliant billing, Cloud-based Salon Management System – access anywhere, anytime
Salon Marketplace Integration – sell beauty products & services online, Best salon management app for parlours,
Best appointment scheduling app for salons, Affordable salon management software India, Mobile app for salon business growth,
Beauty parlour software India, Salon billing software with GST, Best salon management app, Salon staff scheduling software"
        canonical="https://elegantprime.in/services"
        schema={{
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          name: "All in One Basic Software",
          applicationCategory: "BusinessApplication",
          operatingSystem: "Web, Windows, Mac",
        }}
      />
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        mt={{ xs: 1, sm: 2, md: 2, lg: 3 }}
      >
        {/* Left Arrow Button */}
        <IconButton
          size="small"
          onClick={() => navigate("/salon")}
          sx={{ mr: { xs: 1, sm: 10, md: 10, lg: 18 } }}
        >
          <KeyboardBackspaceIcon
            sx={{ color: "#01008B", fontSize: { sm: "30px", xs: "25px" } }}
          />
        </IconButton>

        {/* Tabs */}
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          centered
          sx={{
            "& .MuiTabs-flexContainer": {
              gap: { xs: 1, sm: 10, md: 20, lg: 40 }, // space between tabs
              py: 1.5, // vertical padding
            },
            "& .MuiTabs-indicator": {
              display: "none",
            },
          }}
        >
          <Tab
            value={0}
            label="Services"
            sx={{
              textTransform: "none",
              px: { xs: 2, sm: 4 },
              width: { xs: 100, sm: 200, md: 300, lg: 350 },
              fontWeight: 600,
              boxShadow: 1,
              borderRadius: 1,
              backgroundColor: "#fff",
              color: "#01008B",
              fontSize: { xs: "13px", sm: "14px", md: "16px" },

              "&:hover": {
                backgroundColor: "#e0e0e0",
              },
              "&.Mui-selected": {
                backgroundColor: "#01008B",
                color: "white",
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
              },
            }}
          />
          <Tab
            value={1}
            label="Products"
            sx={{
              textTransform: "none",
              px: { xs: 2, sm: 4 },
              width: { xs: 100, sm: 200, md: 300, lg: 350 },
              fontWeight: 600,
              boxShadow: 1,
              borderRadius: 1,
              backgroundColor: "#fff",
              color: "#01008B",
              fontSize: { xs: "13px", sm: "14px", md: "16px" },

              "&:hover": {
                backgroundColor: "#e0e0e0",
              },
              "&.Mui-selected": {
                backgroundColor: "#01008B",
                color: "white",
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
              },
            }}
          />
        </Tabs>
      </Box>
      <Divider
        sx={{
          borderColor: "#747474",
          borderBottomWidth: "2px",
          mx: 4,
        }}
      />
      {/* {value==0 && ( */}
      <Services value={value} />
    </>
  );
};
